module.exports = __webpack_public_path__ + "static/media/copy_orange_icon.4bd1c28b.svg";